import { formatDistance } from "date-fns";
import React, { useState } from "react";
import { Segment, Button, Icon } from "semantic-ui-react";

export default function EmailsListItem({ email }) {
  // Handle both old format (message as string) and new format (message as object with html/text)
  const messageText =
    typeof email.message === "string"
      ? email.message
      : email.message?.text || "";

  const messageHTML =
    typeof email.message === "object" && email.message?.html
      ? email.message.html
      : null;

  // Default to the HTML rendering (logo, buttons, branding) when it's available,
  // matching what the recipient actually saw — fall back to plain text only if
  // this entry has no HTML on file.
  const [showHTML, setShowHTML] = useState(!!messageHTML);

  // Get subject from either top level or message object
  const emailSubject = email.subject || email.message?.subject || "";

  return (
    <Segment>
      <p className="zero bottom margin text-medium">
        <span className="text blue bold tiny right margin">Subject:</span>{" "}
        {emailSubject}
      </p>
      <p className="text muted">
        {email.updatedAt && email.updatedAt instanceof Date
          ? formatDistance(email.updatedAt, new Date(), {
              addSuffix: true,
            })
          : ""}
      </p>
      {email.from && email.from.length > 0 ? (
        <p className="tiny bottom margin">
          <span className="text blue bold tiny right margin">From:</span>{" "}
          {email.from}
        </p>
      ) : (
        ""
      )}

      <p className="zero bottom margin">
        <span className="text blue bold tiny right margin">To:</span>{" "}
        <span>
          {email.toEmailsAndRoles?.map((toEmailAndRole, index) => (
            <span key={`to${index}`}>
              {index !== 0 && <span>,&nbsp;</span>}
              {toEmailAndRole.role}: {toEmailAndRole.firstName}{" "}
              {toEmailAndRole.lastName} ({toEmailAndRole.email})
            </span>
          ))}
        </span>
        {email.otherEmailsTo && <span>,&nbsp;{email.otherEmailsTo}</span>}
      </p>
      <p className="zero bottom margin">
        <span className="text blue bold tiny right margin">cc:</span>{" "}
        <span>
          {email.ccEmailsAndRoles?.map((ccEmailAndRole, index) => (
            <span key={`cc${index}`}>
              {index !== 0 && <span>,&nbsp;</span>}
              {ccEmailAndRole.role}: {ccEmailAndRole.firstName}{" "}
              {ccEmailAndRole.lastName} ({ccEmailAndRole.email})
            </span>
          ))}
        </span>
        {email.otherEmailsCc && <span>,&nbsp;{email.otherEmailsCc}</span>}
      </p>
      <p>
        <span className="text blue bold tiny right margin">bcc:</span>{" "}
        <span>
          {email.bccEmailsAndRoles?.map((bccEmailAndRole, index) => (
            <span key={`bcc${index}`}>
              {index !== 0 && <span>,&nbsp;</span>}
              {bccEmailAndRole.role}: {bccEmailAndRole.firstName}{" "}
              {bccEmailAndRole.lastName} ({bccEmailAndRole.email})
            </span>
          ))}
        </span>
        {email.otherEmailsBcc && <span>,&nbsp;{email.otherEmailsBcc}</span>}
      </p>
      <div>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <span className="text blue bold tiny right margin">Message:</span>
          {messageHTML && (
            <Button
              size="mini"
              basic
              compact
              onClick={() => setShowHTML(!showHTML)}
              style={{ marginLeft: "8px" }}
            >
              <Icon name={showHTML ? "file text" : "code"} />
              {showHTML ? "Show Text" : "Show HTML"}
            </Button>
          )}
        </div>
        {showHTML && messageHTML ? (
          <div
            style={{
              border: "1px solid #ddd",
              padding: "12px",
              borderRadius: "4px",
              backgroundColor: "#f9f9f9",
              maxHeight: "500px",
              overflow: "auto",
            }}
            dangerouslySetInnerHTML={{ __html: messageHTML }}
          />
        ) : (
          <p style={{ whiteSpace: "pre-line", marginTop: "0" }}>
            {messageText}
          </p>
        )}
      </div>
    </Segment>
  );
}
